var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.9272mm",
    height: "10.3187mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 256.17 221.62",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993231580000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M39.38 221.62c-0.01,-0 -0.04,-0 -0.05,-0 -21.71,0 -39.32,-17.61 -39.32,-39.32 0,-21.71 17.61,-39.32 39.32,-39.32 21.71,0 39.32,17.61 39.32,39.32 0,0.02 0,0.04 0,0.06 -0.03,21.67 -17.59,39.24 -39.27,39.27l-0 0zm0 -73.88c-19.07,-0 -34.55,15.47 -34.55,34.55 0,19.08 15.47,34.55 34.55,34.55 18.97,0 34.4,-15.3 34.55,-34.27 -0.03,-19.07 -15.49,-34.52 -34.55,-34.55l-0 -0.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M128.08 132.35c-24.44,-0 -44.26,-19.82 -44.26,-44.27 0,-24.44 19.82,-44.27 44.27,-44.27 24.44,0 44.27,19.82 44.27,44.27 0,0.02 0,0.04 0,0.06 -0.03,24.42 -19.85,44.2 -44.27,44.2 0,0 0,0 0,0l-0 0zm0 -83.7c-21.69,0.15 -39.21,17.79 -39.21,39.49 0,21.81 17.69,39.49 39.49,39.49 21.7,0 39.34,-17.51 39.5,-39.21 -0,-21.97 -17.82,-39.78 -39.78,-39.78l-0 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993231582112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M216.85 221.62c-21.71,-0 -39.32,-17.61 -39.32,-39.33 0,-21.71 17.61,-39.32 39.32,-39.32 21.71,0 39.32,17.61 39.32,39.32 0,0.02 0,0.04 0,0.06 -0.06,21.68 -17.64,39.24 -39.32,39.27l0 0zm0 -73.88c-0.02,-0 -0.04,-0 -0.06,-0 -19.08,0 -34.55,15.47 -34.55,34.55 0,19.08 15.47,34.55 34.55,34.55 19.08,0 34.55,-15.47 34.55,-34.55 -0.15,-18.95 -15.55,-34.24 -34.49,-34.27l0 -0.28z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 169.17,
    y: 85.75,
    width: 43.19,
    height: 4.77
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M196.73 107.57l-3.35 -3.35 16.08 -16.08 -16.08 -16.08 3.35 -3.41 19.49 19.49 -19.49 19.44z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 125.7,
    y: 129.23,
    width: 4.77,
    height: 43.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M128.08 176.22l-19.43 -19.44 3.35 -3.41 16.08 16.08 16.08 -16.08 3.41 3.41 -19.49 19.44z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 43.81,
    y: 85.75,
    width: 43.19,
    height: 4.77
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M59.44 107.57l-19.44 -19.44 19.44 -19.49 3.41 3.41 -16.08 16.08 16.08 16.08 -3.41 3.35z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 125.7,
    y: 3.81,
    width: 4.77,
    height: 43.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M144.16 22.85l-16.08 -16.08 -16.08 16.08 -3.35 -3.41 19.43 -19.44 19.49 19.44 -3.41 3.41z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc22);
export default __webpack_public_path__ + "static/media/ic_2_2.65c20de8258669d757f68f5982889ae2.svg";
export { ForwardRef as ReactComponent };